import React from 'react';
import Alert from 'components/shared/Alert';
import NoActivitySvg from './svg/NoActivitySvg';

const Finish = () => {
  return (
    <>
      <Alert icon="alert">
        {t('actions.lesson_generate_modal.remember_review')}
      </Alert>
      <NoActivitySvg />
    </>
  );
};

export default Finish;
